export enum VerfahrenLinkRel {
	SEESCHIFFSREGISTER = 'seeschiffsregister',
	BINNENSCHIFFSREGISTER = 'binnenschiffsregister',
	SCHIFFSBAUREGISTER = 'schiffsbauregister',
	LUFTFAHRTPFANDRECHTSREGISTER = 'luftfahrtpfandrechtsregister',
	ERSATZTEILLAGER = 'ersatzteillager',
	SEARCH_VERFAHREN = 'verfahrenSearch',
	VERFAHREN_LIST = 'verfahrenList',
	VORGAENGE = 'vorgaenge',

	KONTAKTE = 'kontakts',
	SET_KONTAKT_ASSIGNED_IN_KATEGORIEN = 'setKontaktAssignedInKategorie',

	CREATE_VORGANG = 'createVorgang',
	REGISTERBLATT_AUSDRUCK = 'registerBlattAusdruck',
	BEGLAUBIGTER_REGISTERBLATT_AUSDRUCK = 'beglaubigterRegisterBlattAusdruck',
	REGISTERBLATT_AUSDRUCK_ENTWURF = 'registerBlattAusdruckEntwurf',
	REGISTERBLATT_AMTLICHER_AUSZUG = 'amtlicherAuszug',
	REGISTERBLATT_SCHIFFSZERTIFIKAT = 'schiffszertifikat',
	REGISTERBLATT_SCHIFFSBRIEF = 'schiffsbrief',
	ADD_UNTERSCHEIDUNGSSIGNAL = 'addUnterscheidungssignal',
	AUFSCHRIFT = 'aufschrift',
	NOTIZ = 'updateNotiz',
	CREATE_SIGNATUR_TASK = 'createSignaturTask',
	BEARBEITEN = 'bearbeiten',
	DELETE = 'delete',
	BEARBEITEN_BEENDEN = 'bearbeitenBeenden',
	UEBERNEHMEN = 'uebernehmen',
	ASSIGN_TO = 'assignTo',
	MARK_AS_ABGELEHNT = 'markAsAbgelehnt',
	ALTERNATIVE_TEXTE = 'alternativeTexte',

	ASSIGN_USIGNAL = 'assignUsignal',
	STANDORT_AKTE = 'standortAkte',
	AR_KENNZEICHEN = 'arKennzeichen',
	ZAEHLBLATT = 'zaehlblatt',
	EXPORT_VERFAHREN = 'exportVerfahren',
	ZUGEORDNETE_VERFAHREN = 'zugeordneteVerfahren',
	ZUGEORDNETE_VERFAHREN_SEARCH = 'zugeordneteVerfahrenSearch',
}

export enum ZaehlblattEntryListLinkRel {
	ZAEHLBLATT_ENTRY_LIST = 'zaehlblattEntryList',
	ADD_AKTIONEN = 'add',
	DELETE_AKTION = 'delete',
}

export enum VerfahrenListLinkRel {
	VERFAHREN_LIST = 'verfahrenList',
	ADD_VERFAHREN = 'add',
}
